module.exports = __webpack_public_path__ + "static/media/close-arrow-white.8ec889af.svg";